import { getBySlug } from "../../../server/Category";
import { reloedFunc, setCategoryItemsSource } from "../../../server/Product";

const ADD_PRODUCT_TITLE_PREFIX = {
  מחלקה: "הוספה למחלקה",
  קטגוריה: "הוספה לקטגוריה",
  "תת-קטגוריה": "הוספה לתת-קטגוריה",
  מקבץ: "הוספה למקבץ",
};

export const getCategoryTypeLabel = ({ categoryLevel = 2, isFamily }) => {
  if (isFamily) return "מקבץ";
  const level = Math.max(1, Math.min(categoryLevel, 3));
  if (level === 1) return "מחלקה";
  if (level === 2) return "קטגוריה";
  return "תת-קטגוריה";
};

export const getAddProductDialogTitle = ({
  categoryName,
  categoryLevel = 2,
  isFamily = false,
}) => {
  const typeLabel = getCategoryTypeLabel({ categoryLevel, isFamily });
  const prefix =
    ADD_PRODUCT_TITLE_PREFIX[typeLabel] || ADD_PRODUCT_TITLE_PREFIX.קטגוריה;
  const name = categoryName?.trim();
  return name ? `${prefix} ${name}` : prefix;
};

export const DIALOG_STEP = {
  INPUT: "input",
  ALREADY_IN_CATEGORY: "already_in_category",
  NOT_FOUND: "not_found",
  CONFIRM_ADD: "confirm_add",
  CATEGORY_CONFLICT: "category_conflict",
};

export const normalizeCheckProductResult = (data) => {
  if (!data) return null;
  if (Array.isArray(data)) return data[0] ?? null;
  return data;
};

export const isNoProductsFoundError = (err) =>
  /no products found/i.test(String(err?.response?.data?.error ?? ""));

export const getProductId = (productData) =>
  productData?.productId ?? productData?.product?.productId;

export const getProductName = (productData) =>
  productData?.name ?? productData?.product?.name ?? "";

export const getExistingCategory = (productData) => {
  const hierarchy = productData?.categories?.[0]?.categoryHierarchy;
  if (!hierarchy?.length) return null;
  const leaf = hierarchy[0];
  if (!leaf?.slug) return null;

  const namedNode =
    hierarchy.find((cat) => cat.name && !cat.isFamily) ||
    hierarchy.find((cat) => cat.name) ||
    leaf;

  return {
    slug: leaf.slug,
    name: namedNode.name || null,
  };
};

export const resolveCategoryDisplayName = async (
  stationId,
  categorySlug,
  fallback,
) => {
  if (fallback && fallback !== categorySlug) return fallback;

  try {
    const catData = await getBySlug(stationId, categorySlug, false, true);
    return catData?.name || fallback || categorySlug;
  } catch {
    return fallback || categorySlug;
  }
};

export const isProductInCategorySlug = (productData, categorySlug) =>
  productData?.categories?.some((entry) =>
    entry?.categoryHierarchy?.some((cat) => cat.slug === categorySlug),
  ) ?? false;

export const refreshCategoryListing = ({
  dispatch,
  stationId,
  categoryPageSlug,
  role,
  isClientView,
  includeInactive,
}) => {
  if (!stationId || !categoryPageSlug) return Promise.resolve();
  dispatch(reloedFunc());
  return getBySlug(
    stationId,
    categoryPageSlug,
    role ? isClientView : true,
    role ? includeInactive : false,
  ).then((res) => {
    if (res) dispatch(setCategoryItemsSource(res));
  });
};
